import { RegionShared } from "@1games-ru/region-shared";
import { Equipment } from "@1games-ru/region-shared/dist/types/inventory/inventory";
import { useCallback } from "react";
import useAppDispatch from "@/core/helpers/useAppDispatch";
import { RpcMpProviderSuccessResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-success-response";
import RpcMpProvider from "@/core/rpc-mp-provider/rpc-mp-provider";
import { setEquipment } from "@/domains/inventory/slice";
import toast from "@/domains/toasts/helpers/toast";

export default function useGetEquipment() {
  const dispatch = useAppDispatch();

  const getEquipment = useCallback(
    async (data: typeof RegionShared.Backend.Requests.GetEquipmentRequest) => {
      const response = await RpcMpProvider.callServer<
        typeof RegionShared.Backend.Requests.GetEquipmentRequest,
        typeof RegionShared.Backend.Responses.GetEquipmentResponse
      >(RegionShared.Backend.Events.Inventory.GetEquipment, data);

      if (response instanceof RpcMpProviderSuccessResponse) {
        dispatch(setEquipment(response.data.equipment as unknown as Equipment));
      } else {
        toast.error(response.message);
        console.log(response.error);
      }
    },
    [],
  );

  return {
    getEquipment,
  };
}
